{
  "DE": "Alemania",
  "AT": "Austria",
  "BE": "Bélgica",
  "DK": "Dinamarca",
  "ES": "España",
  "FR": "Francia",
  "IE": "Irlanda",
  "IT": "Italia",
  "LU": "Luxemburgo",
  "MC": "Mónaco",
  "NL": "Países Bajos",
  "PL": "Polonia",
  "PT": "Portugal",
  "SE": "Suecia"
}
